import { Component, OnInit } from '@angular/core';

import { ToasterService } from '../../_services/toaster.service';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthenicationService} from '../../_services/authenication.service';
import { MessagesService } from "../../_services/messages.service";
import {Ng4LoadingSpinnerService} from "ng4-loading-spinner";

@Component({
  selector: 'app-otp-list',
  templateUrl: './otp-list.component.html',
  styleUrls: ['./otp-list.component.css']
})
export class OtpListComponent implements OnInit {

  returnUrl: string;
  userdetaild: string;
  otpList: any[] = [];

  constructor(private router: Router, private route: ActivatedRoute, private toaster: ToasterService, private authenicationService: AuthenicationService, private messagesservice: MessagesService, private spinnerService: Ng4LoadingSpinnerService) { }

  ngOnInit() {
    this.userdetaild = this.authenicationService.userDetails();
    if (!this.userdetaild) {
      this.router.navigate(['/login']);
    }

    if (!this.userdetaild || this.userdetaild['users_usertype'] == 'employee2') {
      this.router.navigate(['/']);
    }

    let payload = {
      id: this.userdetaild['_id']
    };

    this.getOtpListByCreator(payload);

    this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/';
  }


    getOtpListByCreator(payload) {
      this.messagesservice.getOtpListByCreator(payload)
        .subscribe(
          (data: any) => {
            if (data && data.ResponseCode === '200') {
              this.otpList = data.Data;
            } else {
              this.toaster.showError('OTP', data.ResponseMessage);
            }
          },
          error => {
            this.toaster.showError('OTP', error);
          });
    };



    reloadComponent() {
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.router.onSameUrlNavigation = 'reload';
        this.router.navigate(['/otp']);
    }

}
